import React from "react";
import PhotoSelection from "../PhotoSelection/PhotoSelection";
import { clientConfig } from "../../../../config";

const PhotoSelectionPanel = ({
  photoSelectionPickedIdx,
  errorMode,
  question,
  onPhotoChange,
  containerRef,
}) => {
  const children = question.answersGroup.children || [];

  return (
    <>
      <div
        id={"question_" + question.id}
        ref={containerRef}
        className="questionnaire-question-item-text-container"
        dangerouslySetInnerHTML={{ __html: question.text }}
      />
      <div
        className="questionnaire-question-item-helpblock-container"
        dangerouslySetInnerHTML={{ __html: question.help_block }}
      />
      <div className="questionnaire-answers-photoSelection-container">
        {children.map((child, index) => {
          const photoSrc = child.recipe?.illustration_url
            ? clientConfig.IMAGES_URL + child.recipe.illustration_url
            : null;
          return (
            <PhotoSelection
              errorMode={errorMode}
              questionId={question.id}
              answer={child}
              questionsValidationObject={{}}
              pickedPhotoId={photoSelectionPickedIdx}
              onChangeValue={onPhotoChange}
              photoSrc={photoSrc}
              placeholder={index + 1}
              id={index}
              key={index}
            />
          );
        })}
      </div>
    </>
  );
};

export default PhotoSelectionPanel;
